import { TimeBucketUnits } from '@iotv/datamodel-core';
import { SortOrder } from '@iotv/iotv-v3-types';
import dayjs from 'dayjs';
import { NetWorkDAO } from '../../../../data/NetworkDAO';
import { ConsumerDao } from '../../../../data/ConsumerDAO';
import config from '@iotv/config';
const dynamo = config.aws.dynamoDB;
export const getLastTwentyFourQuery = async () => {
    const query = {
        units: TimeBucketUnits.DAY.valueOf(),
        duration: 1,
        fromDateValue: dayjs().subtract(1, 'day'),
        toDateValue: dayjs(),
        sortOrder: SortOrder.DESCENDING,
    };
    const { data } = await NetWorkDAO.geGatewayMetricsFromTimestream(query);
    if (data) {
        return data;
    }
};
export const getAllGatewaysInDB = async () => {
    const gateways = await ConsumerDao.baseQuery({
        TableName: dynamo.tableName,
        IndexName: dynamo.typesiName,
        ExpressionAttributeNames: {
            '#pk': dynamo.pKey,
            '#type': dynamo.typesiPrimaryKey,
        },
        ExpressionAttributeValues: {
            ':type': 'Gateway',
        },
        KeyConditionExpression: '#type = :type',
        FilterExpression: 'begins_with(#pk, :type)',
        ScanIndexForward: false,
    });
    return gateways.data;
};
export const getLNCStatistics = async () => {
    const gateways = await NetWorkDAO.gateway.AWS.list({ getStatistics: true });
    return gateways.data;
};
// export const getLNSMetrics = async () => {
//   const units: TimeBucketUnits.DAY | TimeBucketUnits.HOUR = TimeBucketUnits.DAY;
//   let iteratedGateway = await iterateGetGatewayMetrics(0, {
//     duration: 1,
//     units: units,
//     sortOrder: SortOrder.ASCENDING,
//     fromDateValue: dayjs().subtract(1, 'day'),
//     toDateValue: dayjs(),
//   });
//   console.log(
//     'WAH iteratedGateway',
//     iteratedGateway.data?.sort((a, b) => a.id.localeCompare(b.id)),
//   );
//   return iteratedGateway.data ?? [];
// };
